export function getRandomNoiseFile(): string {
    const urls = Array.from({ length: 12 }, (_, i) => `/textures/noise/simplex/simplex${i}.png`)



    const randomIndex = Math.floor(Math.random() * urls.length);
    return urls[randomIndex];
}
